import { Component } from 'react';
import Raven from 'raven-js';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class PageErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: {
        componentStack: errorInfo.componentStack
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        rowGap: "200",
        flexGrow: 1,
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "common.pageError.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "common.pageError.description"
          })
        })]
      });
    }
    return this.props.children;
  }
}